export default {
    allCourses(state) {
        return state.courses;
    },
    all_courses(state) {
        return state.all_courses;
    },

    loading(state) {
        return state.loading;
    },

    getKey(state) {
        return state.key
    },

    getSelectedCourse(state) {
        return state.selected_course
    },

    idCourse(state) {
        return state.coureseId;
    },
    CourseName(state) {
        return state.name;
    },
    descriptionCourse(state) {
        return state.description;
    },
    id_video(state) {
        return state.vimeo_Id;
    },
    resourcesLesson(state) {
        return state.resources;
    },
    id_lesson(state) {
        return state.lesson_Id;
    },
    progress_total(state) {
        return state.total_progress;
    },
    id_resource(state) {
        return state.resource_id;
    },
    modules_all(state) {
        return state.allModules;
    },
    lessons_all(state) {
        return state.allLesson;
    },
    resource_all(state) {
        return state.allResources;
    },
    type_resource(state) {
        return state.resource_type;
    },
    video_finish(state) {
        return state.video_finish;
    },
    MODULE_SELECTED(state) {
        return state.module_selected;
    },
};